module.exports = __webpack_public_path__ + "49824f2b19a66f7238ecd87442812be8.png";